exports = module.exports = require("C:\\Users\\kop\\Repos\\webpack\\node_modules\\css-loader\\cssToString.js")();
require("C:\\Users\\kop\\Repos\\webpack\\node_modules\\css-loader\\mergeImport.js")(exports, require("-!C:\\Users\\kop\\Repos\\webpack\\node_modules\\css-loader\\index.js!resources-module/stylesheet-import2.css"), "print, screen");
require("C:\\Users\\kop\\Repos\\webpack\\node_modules\\css-loader\\mergeImport.js")(exports, require("-!C:\\Users\\kop\\Repos\\webpack\\node_modules\\css-loader\\index.js!./stylesheet-import3.css"), "print and screen");
exports.push([module.id, "\r\n\r\n\r\n.rule-import1 {\r\n\tbackground: lightgreen;\r\n}\r\n", ""]);


/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/css-loader!./loaders/_css/folder/stylesheet-import1.css
 ** module id = 5
 ** module chunks = 0
 **/